import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationDetails, CognitoUser, CognitoUserPool, ICognitoUserData } from 'amazon-cognito-identity-js';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  isLoading: boolean = false;
  email_address: string = "";
  password: string = "";
  newPassword: string = "";
  resetPassword: string = "";
  verificationCode: string = "";
  userRequiredAttributes: any = null;
  passwordChangeRequired: boolean = false;
  passwordResetRequired: boolean = false;
  userPool: CognitoUserPool;
  cognitoUser: CognitoUser = {} as CognitoUser;

  constructor(private router: Router) {
    let poolData = {
      UserPoolId: environment.cognitoUserPoolId, // Your user pool id here
      ClientId: environment.cognitoAppClientId // Your client id here
    };

    this.userPool = new CognitoUserPool(poolData);
  }

  ngOnInit(): void { }

  onSignIn(form: NgForm) {
    if (form.valid) {
      this.isLoading = true;
      let authenticationDetails = new AuthenticationDetails({
        Username: this.email_address,
        Password: this.password,
      });

      let userData = { Username: this.email_address, Pool: this.userPool };
      this.cognitoUser = new CognitoUser(userData);
      this.cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          this.router.navigate(["dashboard"])
        },
        newPasswordRequired: (user, required) => {
          this.userRequiredAttributes = required;
          this.passwordChangeRequired = true;
        },
        onFailure: (err) => {
          if(err.code == "PasswordResetRequiredException") {
            this.passwordResetRequired = true;
          } else {
          alert(err.message || JSON.stringify(err));
          }
          this.isLoading = false;
        },
      });
    }
  }

  onChangePassword(form: NgForm) {
    if (form.valid) {
      this.isLoading = true;

      // let userData = { Username: this.email_address, Pool: this.userPool };
      // var cognitoUser = new CognitoUser(userData);

      this.cognitoUser.completeNewPasswordChallenge(this.newPassword, this.userRequiredAttributes, {
        onSuccess: (result) => {
          this.router.navigate(["dashboard"]);
        },
        onFailure: (err) => {
          alert(err.message || JSON.stringify(err));
          this.isLoading = false;
        }
      });
    }
  }

  onResetPassword(form: NgForm) {
    if (form.valid) {
      this.isLoading = true;

      // let userData = { Username: this.email_address, Pool: this.userPool };
      // var cognitoUser = new CognitoUser(userData);

      this.cognitoUser.confirmPassword(this.verificationCode, this.resetPassword, {
        onSuccess: (result) => {
          this.router.navigate(["dashboard"]);
        },
        onFailure: (err) => {
          alert(err.message || JSON.stringify(err));
          this.isLoading = false;
        }
      });
    }
  }
}